import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

type ExpandButtonProps = {
  onClick: () => void;
  expandDirection: string;
};

const ExpandButton: FC<ExpandButtonProps> = ({ onClick, expandDirection }) => {
  const { t } = useTranslate();

  return (
    <button
      type="button"
      className="badge btn-primary"
      onClick={onClick}
      aria-label={t('SeeMore')}
      title={t('SeeMore')}
    >
      <em
        className={`icon ni ni-chevron-${expandDirection}`}
        aria-hidden="true"
      />
    </button>
  );
};

export default ExpandButton;
